import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ImageButtonComponent } from './image-button/image-button.component';
import { ImageViewerComponent } from './image-viewer/image-viewer.component';
import { StudentSelectorComponent } from './student-selector/student-selector.component';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { MarkdownViewerComponent } from './markdown-viewer/markdown-viewer.component';
import { SafePipe } from './pipe';
//import { RecorderComponent } from './recorder/recorder.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { NgcCookieConsentConfig, NgcCookieConsentModule } from 'ngx-cookieconsent';
import { NgxMatInputTelComponent } from 'ngx-mat-input-tel';
import { ActionButtonComponent } from './action-button/action_button.component';
import { AdminTimingsComponent } from './admin-timings/admin-timings.component';
import { BlockCopyDirective } from './block-copy.directive';
import { CardComponent, EduCardSubtitle, EduCardTitle } from './card/card.component';
import { ClockComponent } from './clock/clock.component';
import { AdminDataCardComponent } from './admin-data-card/admin-data-card.component';
import { MoneyCardComponent } from './money-card/money-card.component';
import { MatChipsModule } from '@angular/material/chips';
import { CompletionAnimationComponent } from './completion-animation/completion-animation.component';
import { CookieConsentComponent } from './cookie-consent/cookie-consent.component';
import { DetailItemComponent } from './detail-item/detail-item.component';
import { EduRowComponent } from './edu-row/edu-row.component';
import { HeaderTitleComponent } from './header-title/header-title.component';
import { HighlightedMarkdownViewerComponent } from './highlighted-markdown-viewer/highlighted-markdown-viewer.component';
import { LogoComponent } from './logo/logo.component';
import { PaginatorComponent } from './paginator/paginator.component';
import { ProfileAvatarComponent } from './profile-avatar/profile-avatar.component';
import { SidebarComponent } from './sidebar/sidebar.component';


const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: 'localhost' // or 'your.domain.com' // it is mandatory to set a domain, for cookies to work properly (see https://goo.gl/S2Hy2A)
  },
  palette: {
    popup: {
      background: '#f5f5f5'
    },
    button: {
      background: '#008800'
    }
  },
  theme: 'edgeless',
  type: 'opt-in'
};



@NgModule({
  declarations: [
    SafePipe,
    ImageButtonComponent,
    LoadingSpinnerComponent,
    MarkdownViewerComponent,
    ImageViewerComponent,
    MoneyCardComponent,
    //RecorderComponent,
    CookieConsentComponent,
    DetailItemComponent,
    LogoComponent,
    HeaderTitleComponent,
    CardComponent,
    EduCardTitle,
    EduCardSubtitle,
    EduRowComponent,
    ActionButtonComponent,
    PaginatorComponent,
    ProfileAvatarComponent,
    AdminTimingsComponent,
    BlockCopyDirective,
    HighlightedMarkdownViewerComponent,
    ClockComponent,
    AdminDataCardComponent,
    CompletionAnimationComponent,
    SidebarComponent,
    StudentSelectorComponent
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatSelectModule,
    MatAutocompleteModule,
    CommonModule,
    MatIconModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatProgressBarModule,
    MatChipsModule,
    MatTooltipModule,
    NgcCookieConsentModule.forRoot(cookieConfig),
    NgxMatInputTelComponent
  ],
  exports: [
    LoadingSpinnerComponent,
    SafePipe,
    ImageButtonComponent,
    MarkdownViewerComponent,
    //RecorderComponent,
    CookieConsentComponent,
    DetailItemComponent,
    LogoComponent,
    HeaderTitleComponent,
    CardComponent,
    EduCardTitle,
    EduCardSubtitle,
    EduRowComponent,
    ActionButtonComponent,
    PaginatorComponent,
    ProfileAvatarComponent,
    AdminTimingsComponent,
    BlockCopyDirective,
    HighlightedMarkdownViewerComponent,
    AdminDataCardComponent,
    CompletionAnimationComponent,
    SidebarComponent,
    MoneyCardComponent,
    MatProgressSpinnerModule,
    StudentSelectorComponent
  ],
  providers: []
})
export class SharedModule { }
